var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.397 7.2",
    width: 120,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.156 6.46c.526 0 .953-.427.953-.953v-.953h-.953c-.526 0-.953.427-.953.953s.427.953.953.953z",
    fill: "#0acf83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.202 3.6c0-.526.427-.953.953-.953h.953v1.907h-.953c-.526 0-.953-.427-.953-.953z",
    fill: "#a259ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.202 1.693c0-.526.427-.953.953-.953h.953v1.907h-.953c-.526 0-.953-.427-.953-.953z",
    fill: "#f24e1e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1.74h.953c.526 0 .953.427.953.953s-.427.953-.953.953H3.1z",
    fill: "#ff7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.016 3.6c0 .526-.427.953-.953.953S3.1 4.126 3.1 3.6s.427-.953.953-.953.953.427.953.953z",
    fill: "#1abcfe"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.058 2.32v1.998h.257v-.954h.618v-.248h-.618V2.57h.803v-.25zm1.525.406c.093 0 .168-.075.168-.168S7.675 2.4 7.583 2.4s-.168.075-.168.168c0 .045.018.087.05.12s.074.05.12.05zm-.13.252v1.34H7.7v-1.34h-.255zm1.212-.04c-.342 0-.58.3-.58.632s.24.63.58.63a.51.51 0 0 0 .379-.159v.178a.42.42 0 0 1-.116.287.4.4 0 0 1-.286.12.42.42 0 0 1-.228-.076l-.13.223a.66.66 0 0 0 1.017-.557v-1.24h-.257v.12a.51.51 0 0 0-.379-.159zm-.322.632a.35.35 0 0 1 .166-.33c.114-.07.257-.07.37 0s.177.198.166.33a.35.35 0 0 1-.166.33c-.114.07-.257.07-.37 0s-.177-.198-.166-.33z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.228 3.2a.28.28 0 0 0-.279.279v.848h-.257v-1.34h.257V3.1c.078-.104.202-.164.332-.162.164-.004.317.084.398.227.1-.14.244-.225.4-.227.293 0 .475.236.476.528v.853h-.257v-.85a.28.28 0 0 0-.427-.276.28.28 0 0 0-.124.276v.848H10.5V3.47a.28.28 0 0 0-.279-.279zm2.7-.07a.62.62 0 0 0-.453-.191c-.383 0-.65.324-.65.7s.27.7.65.7a.62.62 0 0 0 .453-.191V4.3h.257V2.96h-.257zm-.85.52c-.013-.16.065-.314.202-.398s.3-.084.446 0a.43.43 0 0 1 .202.398c.013.16-.065.314-.202.398s-.3.084-.446 0a.43.43 0 0 1-.202-.398z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.ad871afd305180efa718ba4eeb2a8360.svg";
export { ForwardRef as ReactComponent };